


































































































import {Component, Prop, Vue, Watch} from 'vue-property-decorator'
import {$} from '@/facade'
import {getN3InvocationBuilder} from '@/model/wallets/invocationsBuilder'
import {NeoHelper} from '@/helpers/NeoHelper'
import OrbitLoadingTransactionStep from '@/components/orbit/OrbitLoadingTransactionStep.vue'
import OrbitInsufficientGasStep from '@/components/orbit/OrbitInsufficientGasStep.vue'
import OrbitUnexpectedErrorStep from '@/components/orbit/OrbitUnexpectedErrorStep.vue'
import OrbitRejectedByTheUserStep from '@/components/orbit/OrbitRejectedByTheUserStep.vue'
import OrbitSuccessStep from '@/components/orbit/OrbitSuccessStep.vue'
import {OrbitHelper} from '@/helpers/OrbitHelper'
import {OrbitProject} from '@/model/resource/OrbitProject'
import {OrbitRemoveProjectStep} from '@/enums/OrbitRemoveProjectStep'
import {PropType} from 'vue'

@Component({
  computed: {
    OrbitRemoveProjectStep() {
      return OrbitRemoveProjectStep
    },
  },
  components: {
    OrbitSuccessStep,
    OrbitLoadingTransactionStep,
    OrbitInsufficientGasStep,
    OrbitUnexpectedErrorStep,
    OrbitRejectedByTheUserStep,
  },
})
export default class OrbitRemoveProjectModal extends Vue {
  @Prop({type: Object as PropType<OrbitProject | null>})
  orbitProject!: OrbitProject | null

  currentStep: OrbitRemoveProjectStep = OrbitRemoveProjectStep.WAITING_SIGNATURE
  transactionHash: string | null = null

  mounted() {
    this.populateResources()
  }

  async populateResources() {
    await OrbitHelper.checkWalletPermissions().catch(() => {
      this.closeModal()
      return
    })

    await this.removeProject()
  }

  async removeProject() {
    try {
      if (
        !$.walletAdapter.n3Address ||
        !this.orbitProject ||
        !this.orbitProject.contract ||
        !this.orbitProject.contract.hash ||
        !this.orbitProject.instanceId
      ) {
        throw new Error('Missing parameters')
      }

      const n3InvocationBuilder = getN3InvocationBuilder()
      const removeOrbitProjectInvocationBuilder = n3InvocationBuilder.removeOrbitProjectInvocation(
        {
          projectScriptHash: this.orbitProject.contract.hash,
          instanceId: String(this.orbitProject.instanceId),
        }
      )

      const transactionHash = await $.walletAdapter.invokeN3Wallet(
        removeOrbitProjectInvocationBuilder
      )

      const isTransactionValid = await NeoHelper.validateTransaction(
        String(transactionHash)
      )

      if (!isTransactionValid) throw new Error()

      this.orbitProject.active = false
      await this.orbitProject.persistOrbitProject()

      this.currentStep = OrbitRemoveProjectStep.REMOVED

      $.toast.success('system.success.persist')
    } catch (e) {
      this.threatError(e)
    }
  }

  onClickCloseModal() {
    if (
      this.currentStep === OrbitRemoveProjectStep.WAITING_SIGNATURE ||
      this.currentStep === OrbitRemoveProjectStep.VALIDATING_TRANSACTION
    ) {
      return
    }

    this.closeModal()
  }

  closeModal() {
    this.currentStep = OrbitRemoveProjectStep.WAITING_SIGNATURE
    this.$emit('close')
  }

  @Watch('$store.state.walletAdapter.n3.address')
  async onN3AddressChange(address: string | null) {
    if (!address) {
      this.closeModal()
      return
    }

    await OrbitHelper.checkWalletPermissions().catch(() => {
      this.closeModal()
    })
  }

  private threatError(error: any) {
    console.error(error)

    if (
      String(error.message).includes('cannot remove project used in a round')
    ) {
      $.toast.error('You cannot remove project used in a round.')
    }

    const isNeonWalletRejected =
      error.message && String(error.message).includes('rejected by the user')

    const isNeoLineWalletRejected =
      error.description &&
      error.description === 'The user cancels, or refuses the dapps request'

    if (isNeonWalletRejected || isNeoLineWalletRejected) {
      this.currentStep = OrbitRemoveProjectStep.REJECTED_BY_THE_USER
      return
    }

    const hasInsufficientFunds =
      error.message && String(error.message).includes('insufficient funds')
    if (hasInsufficientFunds) {
      this.currentStep = OrbitRemoveProjectStep.INSUFFICIENT_GAS
      return
    }

    this.currentStep = OrbitRemoveProjectStep.UNKNOWN_ERROR
  }
}
